module.exports = __webpack_public_path__ + "static/media/minus-footer.a88d50bf.svg";